var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusMonoAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3173 10.8001H13.3173V3.8001C13.3173 3.48184 13.1909 3.17661 12.9658 2.95157C12.7408 2.72653 12.4355 2.6001 12.1173 2.6001C11.799 2.6001 11.4938 2.72653 11.2688 2.95157C11.0437 3.17661 10.9173 3.48184 10.9173 3.8001V10.8001H3.91729C3.59903 10.8001 3.2938 10.9265 3.06876 11.1516C2.84371 11.3766 2.71729 11.6818 2.71729 12.0001C2.71729 12.3184 2.84371 12.6236 3.06876 12.8486C3.2938 13.0737 3.59903 13.2001 3.91729 13.2001H10.9173V20.2001C10.9173 20.5184 11.0437 20.8236 11.2688 21.0486C11.4938 21.2737 11.799 21.4001 12.1173 21.4001C12.4355 21.4001 12.7408 21.2737 12.9658 21.0486C13.1909 20.8236 13.3173 20.5184 13.3173 20.2001V13.2001H20.3173C20.6355 13.2001 20.9408 13.0737 21.1658 12.8486C21.3909 12.6236 21.5173 12.3184 21.5173 12.0001C21.5173 11.6818 21.3909 11.3766 21.1658 11.1516C20.9408 10.9265 20.6355 10.8001 20.3173 10.8001Z",
    fill: "#DBDCDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusMonoAi);
export default __webpack_public_path__ + "static/media/icon-plus-mono-ai.3d51d6bc3100e25e1233aa76edf4ca23.svg";
export { ForwardRef as ReactComponent };